import getTextColor from '../../../utils/getTextColor'
import styles from './DesktopBar.module.css' 

const DesktopBar = ({ data, onSubmit, borderWidth = 1 }) => {
  
  const backgroundColor = data?.backgroundColor?.value
  const barButtonColor = data?.barButtonColor?.value
  const barButtonText = data?.barButtonText?.value
  const barTitle = data?.barTitle?.value
  
  return(
  <div className={styles.topBar} style={{ backgroundColor, borderWidth }}>
  <div className={styles.container}>
    <span
      style={{ color: getTextColor(backgroundColor) }}
      className={styles.desktopBarTitle}
    >
      {barTitle}
    </span>
    <button
      className={styles.cta}
      style={{ backgroundColor: barButtonColor, color: getTextColor(barButtonColor) }}
      onClick={onSubmit}
    >
      {barButtonText}
    </button>
  </div>
  </div>
)}


export default DesktopBar